import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import CommonUtil from "../../../utils/CommonUtil";
import { constants } from "../../../utils/Constants";
import Document from "../../domain/KnowledgeManagement/KnowledgeItem/Document";
import ButtonBar from "../ButtonBar/ButtonBar";
import DropDown from "../DropDown";
import EditableLink from "../EditableLink";
import FileUploader from "../FileUploader";
import SubmitControl from "../SubmitControl";

const getDefaultInputFields = (
  noName,
  noDescription,
  noDateRange,
  selectedDocumentType,
  submitType,
  documentTypes
) => {
  const inputFields = [];

  if (noName === undefined) {
    const inputField = {
      label: labels.name,
      controlId: "name",
      placeholder: labels.namePlaceholder,
      type: "text"
    };
    inputFields.push(inputField);
  }

  if (noDescription === undefined) {
    const inputField = {
      label: labels.description,
      controlId: "description",
      placeholder: labels.descriptionPlaceholder,
      as: "textarea"
    };
    inputFields.push(inputField);
  }

  if (noDateRange === undefined) {
    const inputField = {
      label: labels.dateFromTo,
      controlId: "dateFromTo",
      placeholder: [labels.dateFromPlaceholder, labels.dateToPlaceholder],
      type: "dateRange"
    };
    inputFields.push(inputField);
  }
  if (selectedDocumentType !== undefined) {
    const inputFieldDocType = {
      label: labels.documentType,
      controlId: "documentType",
      placeholder: labels.documentType,
      type: "dropdown",
      dropDownOptions: documentTypes,
      disabled: submitType !== "fileUploader"
    };
    inputFields.push(inputFieldDocType);
  }
    if (selectedDocumentType !== undefined && submitType === "fileUploader") {
    const inputFieldFile = {
      label: labels.file,
      controlId: "documentForUpload",
      type: "uploader"
    };
    inputFields.push(inputFieldFile);
  }

  return inputFields;
};

export const wrapRowField = (key, label, controlId, field) => {
  return (
    <Row key={key}>
      <Col sm="3">
        <Form.Label className="Label">{label}</Form.Label>
      </Col>
      <Col>
        <Form.Group controlId={controlId}>{field}</Form.Group>
      </Col>
    </Row>
  );
};

const getRows = props => {
  const defaultInputFields = getDefaultInputFields(
    props.entity.noName,
    props.entity.noDescription,
    props.entity.noDateRange,
    props.selectedDocumentType,
    props.submitType,
    props.documentTypes
  );

  const inputFields = props.additionalInputFields
    ? defaultInputFields.concat(props.additionalInputFields)
    : defaultInputFields;
  const rows = [];

  for (let i = 0; i < inputFields.length; i++) {
    const inputField = inputFields[i];

    const field = inputField.content ? (
      inputField.content
    ) : inputField.type === "uploader" ? (
      <FileUploader
        multiple={false}
        onUpload={props.onDocumentsUpload}
        ref={props.fileUploaderRef}
        disabled={props.disabled}
        onSelect={props.onDocumentSelect}
        setSelected={props.setSelected}
        isModal
      />
    ) : inputField.type === "link" ? (
      <EditableLink
        title={inputField.label}
        value={props.entity[inputField.controlId]}
        placeholder={inputField.placeholder}
        validationRule={props.validationRules?.[inputField.controlId]}
        changeLinkValue={props.onChange}
        maxLength={props.maxLength.uri}
      />
    ) : inputField.type === "dropdown" ? (
      <DropDown
        value={props.entity[inputField.controlId]}
        options={
          inputField.dropDownOptions
            ? inputField.dropDownOptions.map(x => ({
              value: x,
              label: x.name
            }))
            : undefined
        }
        onChange={props.onChange}
        targetId={inputField.controlId}
        placeholder={inputField.placeholder}
        required={props.validationRules?.[inputField.controlId]}
        createNewOptions={inputField.createNewOptions}
        creator={inputField.creator}
        disabled={inputField.disabled}
        isSearchable={inputField.isSearchable}
      />
    ) : inputField.type === "document" ? (
      <Document
        entity={props.entity}
        messageHandler={props.messageHandler}
        breadcrumbsHandler={props.breadcrumbsHandler}
        ref={props.documentRef}
        hideCreateForm={inputField.quickCreate}
        editable={inputField.editable}
        setStartUploading={props.setStartUploading}
      ></Document>
    ) : (
      <SubmitControl
        autoFocus={i === 0}
        type={inputField.type}
        placeholder={inputField.placeholder}
        value={props.entity[inputField.controlId]}
        validationRule={props.validationRules?.[inputField.controlId]}
        onChange={props.onChange}
        maxLength={props.maxLength?.[inputField.controlId]}
        controlId={inputField.controlId}
        as={inputField.as}
      ></SubmitControl>
    );

    if (!(props.selectedDocumentType === constants.DOCUMENT_TYPE.LINK.id && inputField.controlId === "documentForUpload")) {
      const row = wrapRowField(
        i.toString(),
        inputField.label,
        inputField.controlId,
        field
      );
      rows.push(row);
    }

  }
  return rows;
};

const BasicDialog = props => {
  const entity = props.entity ? props.entity : {};
  let onClick;
  if (
    props.submitType === "fileUploader" &&
    props.fileUploaderRef
  ) {
    if (props.fileUploaderRef.current !== null)
      onClick = props.fileUploaderRef.current.onUpload;
    else
      onClick = props.onDocumentsUpload;
  }

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        onEntered={props.handleEntered}
        size={props.size || ""}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {CommonUtil.constructHeaderTitleAndId(
              props.dialogTitle,
              entity[constants.NEW_ELEMENT_INDICATOR_PROPERTY]
                ? undefined
                : entity.id
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {props.childrenFirst && props.children ? props.children : null}
            {getRows({ ...props, entity })}
            {!props.childrenFirst && props.children ? props.children : null}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <ButtonBar
            affix={false}
            disabled={props.disabled}
            onClose={props.handleClose}
            onSave={props.onSave}
            onUpload={onClick || props.submitType === "fileUploader"}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BasicDialog;
